<template>
  <div>
    <el-dialog class="main_dialog" 
      title="请选择模板" 
      :show-close="false" 
      width="50%" 
      :visible.sync="dialogTempVisible" 
    >
      <div class="export_t">
        <el-button v-if="pageType !== 'exportTemp'" class="excel_btn" @click="openExcelDialog">我的导出</el-button>
        <div class="export_t_search">
        <el-input
          placeholder="模板名称或描述"
          v-model="searchForm.keyword">
        </el-input>
        <el-select v-model="searchForm.platform" placeholder="模板类型" :disabled="pageType == 'exportTemp'" >
          <el-option label="temu" value="temu"></el-option>
          <el-option label="tiktok" value="tiktok"></el-option>
          <el-option label="shein" value="shein"></el-option>
          <el-option label="shopee" value="shopee"></el-option>
        </el-select>
        <el-button class="search_btn" @click="tableSearch">
          搜索 
        </el-button>
      </div>
      </div>
      <div class="temp_classi">
        <div class="temp_classi_item" :class="{active: searchForm.group_id == ''}" @click="changeCategory('')">全部</div>
        <div v-for="(item, index) in classifyList" class="temp_classi_item" :class="{active: searchForm.group_id == item.id}" @click="changeCategory(item.id)">
          {{ item.name }} <span>{{ item.num }}</span>
        </div>
      </div>
      <el-table
        ref="tempTableRef"
        class="main_d_table"
        :data="tempTableData"
        row-key="id"
        @select-all="handleSelectAll"
        @selection-change="handleSelectionChange">
        <el-table-column
          :selectable="(row) => {
            if(pageType !== 'exportTemp') {
              return true;
            }else {
              return row.id !== templateId
            }
          }"
          reserve-selection
          type="selection"
          width="55" />
        <el-table-column
          label="模板名称">
          <template slot-scope="scope">
            {{scope.row.name}}
            <span class="table_tags">{{scope.row.platform}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="创建时间" />
        <el-table-column
          prop="update_time"
          label="更新时间" />
      </el-table>
      <el-pagination
        class="main_pagination"
        background
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :page-size="searchForm.limit"
        :total="tempTableTotal">
      </el-pagination>
      <div style="text-align: right;margin-top: 16px;">
        <el-button class="dialog_confirm" size="small" v-if="pageType == 'exportTemp'" @click="handleSubmitForm" :disabled="!tempRowData" :loading="exportLoading">导 入</el-button>
        <el-button class="dialog_confirm" size="small" v-else @click="handleSubmitForm" :disabled="!product_template_ids.length" :loading="exportLoading">导 出</el-button>
        <el-button class="dialog_cancel" size="small" @click="dialogTempVisible = false">取 消</el-button>
      </div>
    </el-dialog> 

    <el-dialog class="main_dialog" 
      title="我的导出" 
      :show-close="false" 
      width="50%" 
      :visible.sync="dialogExcelVisible" 
    >
      <ExcelTable v-if="dialogExcelVisible" />
      <div style="text-align: right;margin-top: 16px;">
        <el-button class="dialog_cancel" size="small" @click="dialogExcelVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { templateTaskExport, templateGetExcelRecord } from "@/api/templateTask";
import { captureExport } from '@/api/acquisition'
import { tempgroupGetList, tempexportGetList } from '@/api/exportTemp'
import { aiExport } from '@/api/imgAndText'
import { materialExport } from '@/api/material'
import JSZip from "jszip";
import { downloadImages, downloadSingleImage, downloadToZip } from '@/utils/download'

import ExcelTable from '@/components/ExcelTable.vue'
export default {
  name: "ExportAccordTemp",
  props: {
    // exportTemp  模板导入配置
    // ai
    // setPicture  套图模板
    // acquisition 数据采集
    pageType: {
      type: String,
      default: 'setPicture'
    },
    dataIds: {
      type: Array,
      default: () => ([])
    },
    templateId: {
      type: Number,
      default: 0
    }
  },
  components: {ExcelTable},
  data () {
    return {
      product_template_ids: 0,
      tempRowData: null,

      dialogTempVisible: false,
      classifyList: [],
      searchForm: {
        keyword: '',
        platform: '',
        group_id: '',
        user_id: -1,
        page: 1,
        limit: 8
      },
      exportLoading: false,
      tempTableData: [],
      tempTableTotal: 0,

      dialogExcelVisible: false,
    }
  },
  watch: {
    dialogTempVisible(val) {
      if(val) {
        tempgroupGetList({page: 1, limit: 50}).then(res => {
          this.classifyList = res.data.data
        })
        this.getExportTempList()
        this.searchForm.page = 1
        this.searchForm.keyword = ''
        if(this.pageType !== 'exportTemp') {
          this.searchForm.platform = ''
        }
        this.searchForm.group_id = ''
        this.tempRowData = null
        this.dialogTempVisible = true
        this.$nextTick(() => {
          this.$refs.tempTableRef.clearSelection();
        })
        
      }
      console.log(this.pageType);
      
    }
  },
  methods:{
    openExcelDialog() {
      this.dialogExcelVisible = true
    },
    changeCategory(id) {
      if(id == this.searchForm.group_id) return
      console.log(this.searchForm);
      
      this.searchForm.group_id = id
      this.getExportTempList()
    },
    handleSelectAll() {
      if(this.pageType == 'exportTemp') {
        this.$refs.tempTableRef.clearSelection();
      }
    },
    handleSelectionChange(val) {
      if(this.pageType == 'exportTemp') {
        let lastItem = val[val.length - 1]
        if(val.length > 1) {
          this.$refs.tempTableRef.clearSelection()
          this.$refs.tempTableRef.toggleRowSelection(lastItem)
        }
        console.log(val, lastItem);
        this.tempRowData = lastItem
      }else {
        let ids = val.map(item => item.id)
        console.log(ids);
        
        this.product_template_ids = ids
      }
    },
    handleSubmitForm() {
      this.exportLoading = true
      if(this.pageType == 'exportTemp') {
        this.$emit('exportNewTemp', this.tempRowData)
        this.exportLoading = false;
        this.dialogTempVisible = false
      }else {
        let apiMethod = this.pageType == 'ai' ? aiExport : this.pageType == 'setPicture' ? templateTaskExport : this.pageType == 'material' ? materialExport : captureExport
        apiMethod({product_template_ids: this.product_template_ids, group_ids: this.dataIds}).then(res => {
          this.exportLoading = false
          this.$message.success(res.msg);
          // let dataList = []
          // res.data.list.forEach(item => {
          //   dataList.push({
          //     name: item.filename,
          //     url: item.path
          //   })
          // })
          // downloadToZip(dataList, res.data.batch_no + '-模板导出')
          this.dialogTempVisible = false
        })
      }
    },
    getExportTempList() {
      tempexportGetList(this.searchForm).then(res => {
        this.tempTableData = res.data.data
        this.tempTableTotal = res.data.total
      })
    },
    handleCurrentChange(val) {
      this.searchForm.page = val
      this.getExportTempList()
    },
    tableSearch() {
      this.searchForm.page = 1
      this.getExportTempList()
    },
  }
}
</script>
<style lang="scss" scoped>
.temp_classi {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
  padding-bottom: 16px;
  // border-bottom: 1px solid #2C3254;
  .temp_classi_item {
    font-size: 16px;
    margin-left: 16px;
    // color: #EDEDED;
    cursor: pointer;
    span {
      font-size: 14px;
      color: #CCCCCC;
    }
    &.active {
      // color: #FFFFFF;
      font-weight: 600;
    }
  }
}
.table_tags {
  display: inline-block;
  font-size: 12px;
  border-radius: 18px;
  background: #3B4663;
  color: #FFFFFF;
  padding: 3px 10px;
  margin-left: 8px;
}
.export_t {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .excel_btn {
    background: linear-gradient(90deg, #4691E7 0%, #3186E5 100%);
    color: #FFFFFF;
    border: none;
    height: 36px;
    border-radius: 8px;
  }
  .export_t_search {
    // width: 321px;
    display: flex;
    gap: 16px;
    /deep/ .el-input__inner {
      border-radius: 8px;
      background: #F2F3F5;
      height: 36px;
      line-height: 36px;
      border: 1px solid rgba(255, 255, 255, .4);
      color: #737373;
      // padding-right: 90px;
    }
  }
  .search_btn {
    border-radius: 8px;
    background: linear-gradient(90deg, #4691E7 0%, #3186E5 100%);
    height: 36px;
    width: 84px;
    font-size: 14px;
    color: #FFFFFF;
    border: none;
    flex-shrink: 0;
  }
}
.main_pagination {
  background: transparent;
  border: none;
}
</style>